import queryStringBuilder from '../../utils/queryStringBuilder';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getLeads = (queries) => 
    fetch(`${API_URL}/lead?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getLead = (leadId) =>
    fetch(`${API_URL}/lead/${leadId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createLead = (lead) =>
    fetch(`${API_URL}/lead`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(lead)
    })

export const updateLead = (leadId, lead) =>
    fetch(`${API_URL}/lead/${leadId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(lead)
    })

export const deleteLeads = (leadIds) =>
    fetch(`${API_URL}/lead/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ leadIds })
    })

export const exportLeads = (queries) =>
    fetch(`${API_URL}/lead/export?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Authorization': `bearer ${jwt()}`
        }
    })

export const assignLeadsToConsultant = (leadIds, consultantId) => 
    fetch(`${API_URL}/lead/assign`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ leadIds, consultantId })
    })


// WEBPACK FOOTER //
// ./src/services/api/lead.js